module.exports = __webpack_public_path__ + "public/img/logo-dash.d783351e.png";